/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { CmTaxonomy_CmLocTaxonomyImpl_Fragment, CmTaxonomy_CmTaxonomyImpl_Fragment, CmTaxonomy_SosLocationImpl_Fragment } from './CMTaxonomy.fragment';
import { gql } from '@apollo/client';
import { CmTaxonomyFragmentDoc } from './CMTaxonomy.fragment';
export type CmLocTaxonomy_CmLocTaxonomyImpl_Fragment = (
  { __typename?: 'CMLocTaxonomyImpl', postcode?: string | null }
  & CmTaxonomy_CmLocTaxonomyImpl_Fragment
);

export type CmLocTaxonomy_SosLocationImpl_Fragment = (
  { __typename?: 'SOSLocationImpl', postcode?: string | null }
  & CmTaxonomy_SosLocationImpl_Fragment
);

export type CmLocTaxonomyFragment = CmLocTaxonomy_CmLocTaxonomyImpl_Fragment | CmLocTaxonomy_SosLocationImpl_Fragment;

export const CmLocTaxonomyFragmentDoc = gql`
    fragment CMLocTaxonomy on CMLocTaxonomy {
  ...CMTaxonomy
  postcode
}
    ${CmTaxonomyFragmentDoc}`;